
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apt3d/itemLocation",
      function () {
        return require("private-next-pages/apt3d/itemLocation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apt3d/itemLocation"])
      });
    }
  